/**
 * @generated SignedSource<<91d8611efdeb0aeaeb03b00670101909>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarAuctionItemsLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItems_user">;
  readonly " $fragmentType": "PdpRespSimilarAuctionItemsLazy_user";
};
export type PdpRespSimilarAuctionItemsLazy_user$key = {
  readonly " $data"?: PdpRespSimilarAuctionItemsLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarAuctionItemsLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarAuctionItemsLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItems_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "dd144d3238934e2714d1705ccc0245df";

export default node;
